import request from '../../utils/request';
// 敏感词统计 start
// 敏感词统计-列表
export function statistical(params,Authorization) {
  return request({
    url: '/sensitive/record/statistical',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  })
}

// 员工列表
export function usersList(params,Authorization) {
  return request({
    url: '/sensitive/record/users',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  })
}

// 单个员工
export function oneUser(params,Authorization) {
  return request({
    url: '/sensitive/record/oneUser',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },true)
}

// 获取指定聊天记录
export function getChatContent(params,Authorization) {
  return request({
    url: '/api/qywechat/intercept/getDialog/'+params.sendFrom+'/'+params.sendTo+'/'+params.msgId,
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  })
}
// 敏感词统计 end

// 敏感词设置 start

// 新建分类
export function addSensitiveWordType(params,Authorization) {
  return request({
    url: '/api/qywechat/intercept/addSensitiveWordType',
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization
    }
  })
}
// 获取分类列表
export function getSensitiveWordTypeList(Authorization) {
  return request({
    url: '/api/qywechat/intercept/getSensitiveWordTypeList',
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  })
}
// 删除分类
export function delSensitiveWordType(params,Authorization) {
  return request({
    url: '/api/qywechat/intercept/delSensitiveWordType/'+params,
    method: 'delete',
    headers: {
      "authorization": Authorization
    }
  })
}
// 编辑分类
export function updateSensitiveWordType(params,type,Authorization) {
  return request({
    url: 'api/qywechat/intercept/updateSensitiveWordType/'+type,
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization
    }
  })
}
// 获取单个分类
export function getSensitiveWordOneTypeList(params,Authorization) {
  return request({
    url: '/api/qywechat/intercept/getSensitiveWordTypeList/'+params,
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  })
}
// 添加敏感词
export function addSensitiveWord(params,Authorization) {
  return request({
    url: '/api/qywechat/intercept/addSensitiveWord',
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization
    }
  })
}
// 删除敏感词
export function delSensitiveWord(params,Authorization) {
  return request({
    url: '/api/qywechat/intercept/delSensitiveWord/'+params,
    method: 'delete',
    headers: {
      "authorization": Authorization
    }
  })
}
// 获取敏感词列表
export function getSensitiveWordList(params,Authorization,isloading) {
  return request({
    url: '/api/qywechat/intercept/getSensitiveWordList',
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization
    }
  },isloading)
}

// 敏感词统计-单个敏感词触发员工列表
export function getRecordUsersList(params,Authorization,isloading) {
  return request({
    url: '/sensitive/record/user',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },isloading)
}
// 敏感词设置 end

// 敏感词统计列表
export function getSensitiveList(params,Authorization,isloading) {
  return request({
    url: '/sensitive/record/statistical/list',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },isloading)
}
// 敏感词统计-员工列表
export function getUsersList(params,Authorization,isloading) {
  return request({
    url: '/sensitive/record/users',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },isloading)
}

// 获取聊天记录

export function getMsgDetail(params,Authorization,isloading) {
  return request({
    url: '/api/qywechat/getEmpDepart',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },isloading)
}
// 敏感词查询-单个员工
export function getOneUserDetail(params,Authorization,isloading) {
  return request({
    url: '/sensitive/record/oneUser',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },isloading)
}
/** 需求统计-列表 旧版 */
export function getConsultList(params,Authorization,isloading) {
  return request({
    url: '/sensitive/consult/record/statistical/list',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },isloading)
}
// 需求统计-图表
export function getConsultChat(params,Authorization,isloading) {
  return request({
    url: '/sensitive/consult/record/statistical/chat',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },isloading)
}
/** 关键词统计表格数据 新版 */
export function getStatisticalList(params,Authorization,isloading) {
  return request({
    url: '/api/qywechat/msg/statistical/list',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },isloading)
}

/** 需求统计-图表 新版 */
export function staticUser(params,Authorization,isloading) {
  return request({
    url: '/api/qywechat/static/user',
    method: 'post',
    data:params,
    headers: {
      "authorization": Authorization
    }
  },isloading)
}


// 敏感词统计-图表
export function getSensitiveChat(params,Authorization,isloading) {
  return request({
    url: '/sensitive/record/statistical/chat',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },isloading)
}
// 员工统计-图表
export function getUsersChat(params,Authorization,isloading) {
  return request({
    url: '/sensitive/record/user/chat',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  },isloading)
}

// // 需求统计-列表
// export function getConsultList(params,Authorization,isloading) {
//   return request({
//     url: '/sensitive/consult/record/statistical',
//     method: 'get',
//     params,
//     headers: {
//       "authorization": Authorization
//     }
//   },isloading)
// }